import doctorImg from '../../../assets/images/hero-section/doctor.png'
// import appStoreIcon from '../../../assets/images/icons/appstore.svg'
// import gPlayIcon from '../../../assets/images/icons/googleplay.svg'

import './_HeroSection.scss'

const HeroSection = () => {
  return (
    <div className='HeroSection section-padding'>
      <div className='container'>
        <div className='img-box'>
          <img src={doctorImg} alt='doctor' className='img' />
        </div>
        <div className='text-box'>
          <h2 className='title'>Not an ordinary doctor's office</h2>
          <p className='text'>
            Get 24/7 on-demand virtual care. Or book appointments with our app. Most insurances accepted.
          </p>
          {/*<div className='links'>*/}
          {/*  <a href='https://google.com' target='_blank' rel='noreferrer' className='link'>*/}
          {/*    <img src={appStoreIcon} alt='Download in the AppStore' />*/}
          {/*  </a>*/}
          {/*  <a href='https://google.com' target='_blank' rel='noreferrer' className='link'>*/}
          {/*    <img src={gPlayIcon} alt='Get in on GooglePlay' />*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  )
}


export default HeroSection
